import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpEvent, HttpHeaders, HttpProgressEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { SasTokenService } from './sas-token.service';
import { filter, Observable, switchMap } from 'rxjs';
import { ICompany, IUser } from '../../../assets/types/dtoTypes';
import { DataService } from './data.service';

@Injectable( {
  providedIn: 'root',
} )
export class AzureService {
  private dataService = inject(DataService);
  private http = inject(HttpClient);
  private sasTokenService = inject(SasTokenService);

  private usersUrl = `${environment.apiUrl}/users`;

  private companiesURL = `${environment.apiUrl}/companies`;

  // private cdnBaseUrl = environment.cdnBaseUrl;

  private blobBaseUrl = environment.blobBaseUrl;


  constructor() {
  }

  public uploadFileToBlob(
    sasToken: string,
    file: File,
    fileUrl: string,
  ): Observable<HttpEvent<unknown>> {
    const blobUrl = `${fileUrl}?${sasToken}`;
    const headers = new HttpHeaders( {
      'x-ms-blob-type': 'BlockBlob',
      'Content-Type': file.type,
    } );

    const req = new HttpRequest( 'PUT', blobUrl, file, {
      headers,
      reportProgress: true,
    } );

    return this.http.request<HttpProgressEvent | HttpResponse<unknown>>( req ).pipe(
      filter( ( event ) => event instanceof HttpResponse ),
    );
  }

  public updateProfileImage( userId: string, file: File ): Observable<Partial<IUser>> {
    this.dataService.clearCache();
    const blobUrl = `${this.blobBaseUrl}/user-profiles/${userId}/` + file.name;

    return this.sasTokenService.getSasToken( userId, file.name ).pipe(
      switchMap( ( sasToken ) => this.uploadFileToBlob( sasToken, file, blobUrl ) ),
      switchMap( () => {
        const cdnUrl = `${this.blobBaseUrl}/user-profiles/${userId}/` + file.name;
        return this.updateUserProfileImage( userId, cdnUrl );
      } ),
    );
  }

  public updateCompanyImage( companyId: string, file: File ): Observable<ICompany> {
    this.dataService.clearCache();
    const blobUrl = `${this.blobBaseUrl}/company-profiles/${companyId}/` + file.name;

    return this.sasTokenService.getSasTokenForCompany( companyId, file.name ).pipe(
      switchMap( ( sasToken ) => this.uploadFileToBlob( sasToken, file, blobUrl ) ),
      switchMap( () => {
        const cdnUrl = `${this.blobBaseUrl}/company-profiles/${companyId}/` + file.name;
        return this.updateCompany( companyId, { logoUrl: cdnUrl } );
      } ),
    );
  }



  public createUserProfileMaterial( userId: string, file: File ): Observable<any> {
    this.dataService.clearCache();
    const blobUrl = `${this.blobBaseUrl}/user-profiles/${userId}/` + file.name;

    return this.sasTokenService.getSasToken( userId, file.name ).pipe(
      switchMap( ( sasToken ) => this.uploadFileToBlob( sasToken, file, blobUrl ) ),
    );
  }

  public updateUserProfileMaterial( userId: string, file: File ): Observable<any> {
    this.dataService.clearCache();
    const blobUrl = `${this.blobBaseUrl}/user-profiles/${userId}/` + file.name;

    return this.sasTokenService.getSasToken( userId, file.name ).pipe(
      switchMap( ( sasToken ) => this.uploadFileToBlob( sasToken, file, blobUrl ) ),
    );
  }


  private updateUserProfileImage( userId: string, fileUrl: string ): Observable<Partial<IUser>> {
    const url = `${this.usersUrl}/${userId}`;
    return this.http.put<Partial<IUser>>( url, { profileImageUrl: fileUrl } );
  }


  updateCompany( id: string, data: Partial<ICompany> ): Observable<ICompany> {
    const url = `${this.companiesURL}/${id}`;
    return this.http.put<ICompany>( url, data );
  }
}
